import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  register('/service-worker.js', {
    ready() {
      // console.log('App is ready to work offline.')
    },
    registered() {
      // console.log('Service worker has been registered.')
    },
    cached() {
      console.log('Content has been cached for offline use.')
    },
    updatefound(registration) {
      console.log('New content is downloading in the background.');
      window.swRegistration = registration;
      window.dispatchEvent(new CustomEvent('sw-update-downloading'));
    },
    updated(registration) {
      console.log('New content is available; notifying app.');
      window.swRegistration = registration;

      // Dispatch custom event as a reliable bridge
      window.dispatchEvent(new CustomEvent('sw-update-waiting'));
    },
    offline() {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error(error) {
      console.error('New Error during service worker registration:', error);
      window.dispatchEvent(new CustomEvent('sw-update-error', { detail: error }));
    }
  })
}
